export default __webpack_public_path__ + "static/media/1837.322a1e9b.png";